export default __webpack_public_path__ + "static/media/26.1abe755d.jpg";